// Products API. Read endpoints used by the sale view; write endpoints used by admin.

import { api } from "../../lib/api";
import type { ProductVisualKey } from "@ventas/shared";

export type Product = {
  id: number;
  name: string;
  categoryId: number | null;
  category: string | null;
  visualKey: ProductVisualKey;
  sizeGuides: Array<{ id: number; name: string; values: string[]; active: boolean }>;
  active: boolean;
  unitsSold: number;
};

export type ProductCategory = { id: number; name: string; iconKey: ProductVisualKey; active: boolean };

export const productsApi = {
  list: (params: { search?: string; active?: boolean } = {}) => {
    const q = new URLSearchParams();
    if (params.search) q.set("search", params.search);
    if (params.active !== undefined) q.set("active", String(params.active));
    const qs = q.toString();
    return api<Product[]>(`/api/products${qs ? `?${qs}` : ""}`);
  },
  categories: () => api<ProductCategory[]>("/api/products/categories"),
  create: (body: { name: string; categoryId?: number | null; sizeGuideIds?: number[]; visualKey?: ProductVisualKey }) =>
    api<Product>("/api/products", { body }),
  update: (id: number, body: Partial<{ name: string; categoryId: number | null; sizeGuideIds: number[]; visualKey: ProductVisualKey; active: boolean }>) =>
    api<Product>(`/api/products/${id}`, { method: "PATCH", body }),
  deactivate: (id: number) =>
    api<{ ok: true }>(`/api/products/${id}`, { method: "DELETE" }),
  reactivate: (id: number) =>
    api<Product>(`/api/products/${id}/reactivate`, { method: "POST", body: {} }),
};
